import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../classes/user';
import { BaseService } from './base.service';
import { FilterLeague } from '../classes/filterCrest';

@Injectable({
    providedIn: 'root',
  })
  export class LeagueService extends BaseService{
    constructor(http: HttpClient){
        super(http);
        this.entity = 'crest';
    }

  private filterObs$: BehaviorSubject<FilterLeague> = new BehaviorSubject(new FilterLeague());
    getFilterObs(): Observable<FilterLeague> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterLeague) {
          this.filterObs$.next(filter);
    }

  }